<template>
  <div class="home-content-page-v">
    <div class="content-one">
      <content-title title="数据源"></content-title>
      <div class="output-content">
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>当前数据选择</span>
            <a href="javascript:;" class="checkbox-one" @click="changeCase(caseData)" v-for="caseData in caseList">
              <img src="~assets/checked-2.png" alt="" v-if="activeCase.key === caseData.key">
              <img src="~assets/unchecked-2.png" alt="" v-else>
              <div class="checkbox-label">
                {{caseData.name}}
              </div>
            </a>
            <span v-if="caseList.length === 0" class="app-note">无可选case数据，请先导入！</span>
          </div>
        </div>
        <div class="m-line">
        </div>
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>数据导入</span>
            <a href="javascript:;" class="checkbox-one" @click="activeImportWayKey = wayData.key" v-for='wayData in importWays'>
              <img src="~assets/checked-2.png" alt="" v-if="wayData.key === activeImportWayKey">
              <img src="~assets/unchecked-2.png" alt="" v-else>
              <div class="checkbox-label">
                {{wayData.name}}
              </div>
            </a>
            <a href="javascript:;" class="output-btn btm-btn" @click="startImport(false)">导入</a>
            <el-dialog title="系统提醒" :visible.sync="dialogVisible" size="tiny" :before-close="handleClose">
              <span>当前case尚未存储，请确定是否丢弃该case。</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回存储</el-button>
                <el-button type="primary" @click="dialogVisible = false;startImport(true)">丢弃并导入</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContentTitle from '../components_bit/ContentTitle'
  export default {
    components: {
      ContentTitle
    },
    methods: {
      startImport (throwAway) {
        if (this.activeCase.status === 'new' && !throwAway) {
          this.dialogVisible = true
        } else {
          this.$store.dispatch('addCase', this.activeImportWayKey === 'demo2' ? '石化DEMO' : '零售DEMO')
          this.$store.dispatch('setSourceDataType', this.activeImportWayKey === 'demo2' ? 'oil' : 'shop')
          this.$store.dispatch('initMapOption')
          this.$store.dispatch('loadSourceData', this.activeImportWayKey === 'demo2' ? 'source_data_oil.json' : 'source_data_shop.json')
          this.$router.push({name: 'cycle'})
        }
      },
      handleClose () {
        this.dialogVisible = false
      },
      changeCase (data) {
        this.$store.dispatch('switchCase', data.key)
        this.$router.push({name: 'cycle'})
      }
    },
    computed: {
      caseList: {
        get () {
          return this.$store.getters.caseList
        }
      },
      activeCase: {
        get () {
          return this.$store.getters.activeCase
        }
      }
    },
    data () {
      return {
        dialogVisible: false,
        importWays: [{
          name: '零售DEMO',
          key: 'demo1'
        },
        {
          name: '石化DEMO',
          key: 'demo2'
        }],
        activeImportWayKey: 'demo1',
        outPutWays: [{
          name: '存储至浏览器',
          key: 'browser'
        },
        {
          name: '导出至Excel',
          key: 'excel'
        }],
        activeOutPutWayKey: 'browser',
        down1: true
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .content-one {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-bottom: 2em;
  }
  .output-btn {
    align-self: flex-end;
    color:#fff;
    background-color: @bak-color-2;
    padding: 0.5em 1.5em;
    text-align: center;
    border-radius: 0.3em;
    letter-spacing: 0.1em;
  }
  .output-content {
    flex:1;
    .content-shadow;
    .content-bottom-radius;
    display: flex;
    padding: 2em;
    min-height: 22em;
    background-color: #fff;
  }
  .checkbox-label {
    .output-btn {
      margin-left: 3em;
    }
  }
  .btm-btn {
    margin: 1em 0 0 2em;
  }
  .m-line {
    width: 2px;
    background-color: #ccc;
    margin: 1.5em 2.2em 1.5em 0;
  }
  .output-content-1 {
    flex: 1;
    margin: 1em 2.5em 1em;
    display: flex;

  }
  .checkbox-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 1.13em;
      padding-bottom: 0.5em;
      color: @bak-color-2;
    }
    .app-note {
      padding: 2em 0 0 2em;
      font-size: 2em;
      color: #999;
    }
  }

  .checkbox-one {
    display: flex;
    align-items: center;
    height: 3.4em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding-right: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// import.vue?eb2921c4